import type { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import { twMerge } from "tailwind-merge";

import type { Require } from "@/types/Require";

export function CircleButton({
  className,
  size = 24,
  children,
  ...props
}: { size?: number } & Require<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, "type">) {
  return (
    // oxlint-disable-next-line button-has-type
    <button
      className={twMerge(
        "rounded-full p-2 not-disabled:cursor-pointer hover:not-disabled:bg-black/5 disabled:text-placeholder",
        className,
      )}
      {...props}
    >
      <div className="flex items-center justify-center" style={{ width: size, height: size }}>
        {children}
      </div>
    </button>
  );
}
